import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

export interface OrderNumberStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    orderNumber?: TypographyProps;
}
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const orderNumberStyles: OrderNumberStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
            font-family: 'Lato',sans-serif;
            letter-spacing: 0;
            line-height: 24px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            margin-right: 5px;
            color: #002554;        
            font-size: 14px;
            font-family: 'Roboto', sans-serif;
            font-weight: bold;
            display: inline-block;
            &:after {
                content: ':';
                display: inline-block;
            }
        `,
    },
    orderNumber: {
        css: css`
            color: #333F48;
            font-size: 14px;
        `,        
    },
};

const styles = orderNumberStyles;

const OrderNumber: FC<Props> = ({ orderData }) => {
    const { value: order } = useContext(OrderStateContext);

    if ((!order || !order.erpOrderNumber)&&(!orderData || !orderData.erpOrderNumber)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderNumber">
                {translate("Order #")}
            </Typography>
            <Typography {...styles.orderNumber} aria-labelledby="orderNumber">{order?.erpOrderNumber||orderData?.erpOrderNumber}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderNumber),
    definition: {
        allowedContexts: [OrderDetailsPageContext,"OrderStatusPage"],
        group: "Order Details",
    },
};

export default widgetModule;